import { USER_ROLES } from 'cpool-constants';
import type { USER_ROLE } from 'cpool-constants';

// Mirrors backend getVisibleChats scoping per role.
export function getVisibilityHintKey(role: USER_ROLE | undefined, isPartnerTab: boolean) {
    if (isPartnerTab) {
        switch (role) {
            case USER_ROLES.admin:
                return 'WHATSAPP_CHAT.LIST.VISIBILITY_HINT.PARTNERS_ADMIN';
            case USER_ROLES.division_leader:
                return 'WHATSAPP_CHAT.LIST.VISIBILITY_HINT.PARTNERS_DIVISION_LEADER';
            default:
                return 'WHATSAPP_CHAT.LIST.VISIBILITY_HINT.PARTNERS';
        }
    }
    switch (role) {
        case USER_ROLES.admin:
            return 'WHATSAPP_CHAT.LIST.VISIBILITY_HINT.ADMIN';
        case USER_ROLES.division_leader:
            return 'WHATSAPP_CHAT.LIST.VISIBILITY_HINT.DIVISION_LEADER';
        case USER_ROLES.team_leader:
            return 'WHATSAPP_CHAT.LIST.VISIBILITY_HINT.TEAM_LEADER';
        default:
            return 'WHATSAPP_CHAT.LIST.VISIBILITY_HINT.ADVISER';
    }
}
